import { useQuery, useSuspenseQuery } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { featureFlagSchema } from '../../../common/validations'

import { get } from 'api/apiClient'

const params = {
  queryKey: [API_ENDPOINTS.FEATURE_FLAGS],
  queryFn: () => get(API_ENDPOINTS.FEATURE_FLAGS, featureFlagSchema),
}

export const useAPIGetFeatureFlags = () => useQuery(params)

export const useAPIGetFeatureFlagsSuspense = () => useSuspenseQuery(params)
